'use strict';

function sendXHRRequest(url, headers, bodyData) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    for (const header in headers) {
      xhr.setRequestHeader(header, headers[header]);
    }
    xhr.onreadystatechange = function () {
      if (this.readyState !== XMLHttpRequest.DONE) {
        return;
      }
      if (this.status !== 200) {
        console.internal("Failed to notify cloud logging API, request unsuccessful", this.response);
        return reject({message: 'Status code ' + this.status});
      }
      return resolve(xhr.responseText);
    }
    xhr.send(JSON.stringify(bodyData));
  });
}

function sendNodeRequest(url, headers, bodyData) {
  return new Promise((resolve, reject) => {
    const https = require('https');
    const data = JSON.stringify(bodyData)

    const req = https.request(url, {method: 'POST', headers}, (res) => {
      res.on('data', (d) => {
        const response = d.toString();
        if (res.statusCode !== 200) {
          return reject(response);
        }
        resolve(response);
      })
    })

    req.on('error', (error) => {
      console.internal("Unable to reach logging proxy, error: ", error);
      reject(error);
    })

    req.write(data)
    req.end()
  });
}

module.exports = {
  async sendPostRequest(url, headers, data) {
    try {
      if (window) {
        return await sendXHRRequest(url, headers, data);
      }
    } catch (e) {
      if (e.name === 'ReferenceError') {
        return await sendNodeRequest(url, headers, data);
      }
      console.internal(e);
    }
    return null;
  }
}
